import "./Kontaktai.css";
import Atsiliepimai from "./atsiliepimai/Atsiliepimai.jsx";
import ImageFetcher from "../../components/ImageFetcher.jsx";

function Kontaktai() {
  const mapQuery = encodeURIComponent("Harmony feeling Gargždai, Lithuania");
  return (
    <section
      id="contact"
      className="kontaktai-section"
      style={{
        backgroundImage: `url(https://res.cloudinary.com/dvuaaubys/image/upload/v1764855158/4_n6ss1z.jpg)`,
      }}
    >
      <div className="kontaktai-container">
        <div className="kontaktai-cards-row">
          <div className="kontaktai-card kontaktai-light-card">
            <div className="google-maps">
              <iframe
                title="Google Map"
                src={`https://www.google.com/maps?q=${mapQuery}&z=15&output=embed`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <p className="section-contacts">
              <span className="block">
                Telefonas registracijai ar pasiteiravimui:{" "}
                <a href="tel:(0-636) 68728" className="contact-link">
                  (0-636) 68728
                </a>
              </span>
            </p>
            <div className="social-icon-container">
              <a
                href="https://www.facebook.com/Harmonyfeelings"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ImageFetcher
                  image="Facebook_Logo_Primary_jcacxb"
                  name="facebook-icon"
                  width={40}
                  height={40}
                />
              </a>
              <a
                href="https://www.instagram.com/harmony_feelings"
                target="_blank"
                rel="noopener noreferrer"
              >
                <ImageFetcher
                  image="Instagram_Glyph_Gradient_qzf6jc"
                  name="instagram-icon"
                  width={40}
                  height={40}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Atsiliepimai />
    </section>
  );
}

export default Kontaktai;
